import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseDecorativeHeaderTokens = {};
//
// Helpers
//
export const CFBaseDecorativeHeaderHelpers = {
    wrapperAlignment: ({ hasGraphic }) => hasGraphic
        ? css `
          justify-content: space-between;
        `
        : css `
          justify-content: flex-end;
        `,
};
//
// Element Styles
//
export const CFBaseDecorativeHeaderStyles = {
    DecorationsWrapper: css `
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: ${CFTokens.SPACER.D}px;
    ${CFBaseDecorativeHeaderHelpers.wrapperAlignment}
  `,
    DecorationsWrapperWithGap: css `
    gap: ${CFTokens.SPACER.MD};
    ${CFBaseDecorativeHeaderHelpers.wrapperAlignment}
  `,
    Root: css `
    padding: 0;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: ${CFTokens.SPACER.D}px;
  `,
    RootWithGap: css `
    gap: ${CFTokens.SPACER.MD};
  `,
};
